/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import RelationshipCondition from 'cio/app-models/conditions/relationship';
import { DataSourceLabelVariant } from 'cio/utils/data-source-label';
import ObjectAttributeCondition, { ObjectAttributeSource } from 'cio/app-models/conditions/object-attribute';

interface Args {
  condition: RelationshipCondition;
  filter: ObjectAttributeCondition;
  index: number;
  depth?: number;
  labelVariant?: DataSourceLabelVariant;
  labelTruncate?: boolean;
  objectName: string;
  containerClasses?: string;
}

export default class CioConditionViewerRelationship extends Component<Args> {
  get attributeSource() {
    let isObjectAttribute = this.args.filter.objectAttributeSource === ObjectAttributeSource.ObjectAttribute;

    return `${isObjectAttribute ? this.args.objectName : 'Relationship'} attribute`;
  }
}
